import React from 'react';
import { observer } from 'mobx-react-lite';
import { TimerUI } from '../features/timer/ui/timer-ui';

export const TimerObserver: React.FC = observer(() => {
  return <TimerUI />;
});
